import axios from "axios";
import { axiosWithKey } from '~/axios'
import { getToken} from '~/redux/user/tokens'
import getCountryCode from '~/tools/userEnvironment/getCountryCode';
import { includes } from 'lodash';

export function getEmailExists(email) {
  
  return getToken().then(token => {
     return axiosWithKey.post('/identity/email',
          {
            email: email,
          	headers:{
            		Authorization: token
          	}
        })
        .then(response => {
        	return response.data.email !== undefined;
        })
        .catch(error => {
        	if(error.response.status === 404){
        		return false;
        	}else{
        		console.log('There was an error finding this email: ' + email)
        		console.log(error);
        	}
        });
  });
}

export function validateCustomerCard(mercadoToken, site, email, userId, publicKey, paymentMethodId, issuerId) {
	return getToken().then(token => {
		return axios({
			method: "POST",
			url: `${
				window.settings.apiBaseUrl
			}/payments/mercadopago/validate_customer`,
			params: { site: site, platform: "web_browser" },
			headers: {
				Authorization: token,
				"x-api-key": window.settings.baseAPIKey
			},
			data: {
				mercadopagoToken: mercadoToken,
				site: site,
				email: email,
				userId: userId,
				publicKey: publicKey,
				paymentMethodId: paymentMethodId,
				issuerId: issuerId
			}
		})
		.then(res=>{
			return res;
		})
		.catch(error=>{
			return error.response;
		})
	})
}

export function getActivePaymentMethod(paymentHandler) {
	if (paymentHandler) {
      return paymentHandler;
    } else {
      return getCountryCode().then(country => {
        // if (window.settings.paymentProviders && window.settings.paymentProviders.juspay && window.settings.paymentProviders.juspay.country === country) { // When JusPay enabled
        //   return this.setState({ form: 'juspay' });

        // } else { // When JusPay is not enabled then Either ccavenue or SSL or Strip will run

          var k = null, providers = window.settings.paymentProviders;

          for (k in providers) {
            if (includes(providers[k].country, country)) {
              return k
            }
          }
          for (k in providers) {
            if (includes(providers[k].country, 'ROW')) {
              return k
            }
          }
          console.log('Error. Payment ROW not found. Defaulting to stripe');
          return 'stripe';
        // }
      });
    }
}